<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-title>Features</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>

  <div sxRow sxPadding="medium" sxGap="10px">

    <div sxBorderWidth="1px" sxBorderColor="one" sxRadius="medium" sxWidth="fill" sxPadding="medium" sxGap="10px" sxCol>
      <list-feature (update)="updateFeature($event)"></list-feature>
    </div>

    <div sxWidth="400px" sxCol sxPadding="medium" sxBackground="light" sxRadius="medium" sxGap="10px">
      <div sxRow sxDistribution="spaceBetween" sxAlign="end">
        <h1>{{featureDto._id ? 'Edit' : 'Create'}} Feature</h1>
        <super-button *ngIf="featureDto._id" (click)="resetDto()" padding="0" iconStart="add-outline" size="small" type="clear">Create New</super-button>
      </div>

      <ion-select [(ngModel)]="featureDto.featureGroup" label="Feature Group" interface="popover" sxRadius="medium" sxBorderWidth="1px" sxBorderColor="one"
                  sxPadding="medium">
        <ion-select-option *ngFor="let group of featureGroups" [value]="group._id">{{group.name}}</ion-select-option>
      </ion-select>

      <super-input label="Name" [(value)]="featureDto.name"></super-input>
      <super-input label="Description" [(value)]="featureDto.description"></super-input>

      <ion-select [(ngModel)]="featureDto.priceModel" label="Pricing Model" interface="popover" sxRadius="medium" sxBorderWidth="1px" sxBorderColor="one"
                  sxPadding="medium">
        <ion-select-option  [value]="'Quota-Based'">Quota-Based</ion-select-option>
        <ion-select-option  [value]="'Pay-Per-Use'">Pay-Per-Use</ion-select-option>
      </ion-select>
      <super-input *ngIf="featureDto.priceModel == 'Quota-Based'" label="Default Quota" [(value)]="featureDto.defaultQuota"></super-input>
      <super-input *ngIf="featureDto.priceModel == 'Pay-Per-Use'" label="Default Price" [(value)]="featureDto.defaultQuota"></super-input>



      <super-button *ngIf="!featureDto._id" [action]="create" [showError]="true">Create</super-button>
      <super-button *ngIf="featureDto._id" [action]="update" [showError]="true">Update</super-button>
    </div>

  </div>

</ion-content>
